import type { ReactNode } from 'react';
import { inteiro, moeda } from '../lib/formato.js';

interface Props {
  rotulo: string;
  valor: number;
  sub?: ReactNode;
  familia?: 'atual' | 'rtc' | 'ret';
  hero?: boolean;
  /** Contagens não levam duas casas decimais. */
  contagem?: boolean;
}

export function Tile({ rotulo, valor, sub, familia = 'atual', hero, contagem }: Props) {
  const classes = ['tile'];
  if (hero) classes.push('hero');
  if (familia === 'rtc') classes.push('rtc');
  if (familia === 'ret') classes.push('ret');
  if (!contagem && Math.abs(valor) < 0.005) classes.push('zero');

  return (
    <div className={classes.join(' ')}>
      <div className="lab">{rotulo}</div>
      <div className="val">{contagem ? inteiro(valor) : moeda(valor)}</div>
      {sub ? <div className="sub">{sub}</div> : null}
    </div>
  );
}
